import sanity from '@/sanity'
import districts from '@/config/districts'

/* eslint no-shadow: ["error", { "allow": ["state"] }] */

export default {
  setLoading({ commit }, loading = true) {
    commit('SET_LOADING', loading)
  },
  toggleMapVisibility({ state, commit }) {
    commit('SET_MAP_VISIBLE', !state.mapVisible)
  },
  resetFilters({ commit }) {
    commit('SET_FILTERS', {
      search: null,
      location: null,
      districts: [],
      seasons: []
    })
  },
  setFilter({ commit }, filter) {
    commit('SET_FILTER', filter)
  },
  fetchData({ dispatch, state }) {
    Promise.all([
      dispatch('fetchSettings'),
      dispatch('fetchDistricts'),
      dispatch('fetchSeasons'),
      dispatch('fetchLocations'),
      dispatch('fetchProductions')
    ]).then(() => {
      dispatch('setLoading', false)

      // Auto-set season filter to latest season on load
      const [{ _id: latestSeason }] = state.seasons
      dispatch('setFilter', { filter: 'seasons', value: [latestSeason] })
    })
  },
  fetchDistricts({ commit }) {
    commit('SET_DISTRICTS', districts)
    return Promise.resolve()
  },
  fetchSettings({ commit }) {
    // prettier-ignore
    const query = `*[_type == "siteSettings" && _id == "siteSettings"][0] {
      _id,
      _type,
      meta_title,
      meta_description,
      meta_image,
      about,
      legal
    }`

    return sanity.fetch(query).then(
      (settings) => {
        commit('SET_SETTINGS', settings)
      },
      (error) => {
        commit('SET_ERROR', error)
      }
    )
  },
  fetchSeasons({ commit }) {
    // prettier-ignore
    const query = `*[_type == "season"] {
      _id,
      _type,
      title,
      "slug": coalesce(slug.current, _id),
      claims,
      dateStart,
      dateEnd,
      posters
    } | order(dateStart desc, dateEnd desc)`

    return sanity.fetch(query).then(
      (items) => {
        commit('SET_SEASONS', items)
      },
      (error) => {
        commit('SET_ERROR', error)
      }
    )
  },
  fetchLocations({ commit }) {
    // prettier-ignore
    const query = `*[_type == "location"] {
      _id,
      _type,
      title,
      "slug": coalesce(slug.current, _id),
      address,
      district,
      location,
      url,
      images
    } | order(title asc)`

    return sanity.fetch(query).then(
      (items) => {
        const locationsWithLabels = items.map((location, index) => {
          return {
            label: index + 1,
            ...location
          }
        })
        commit('SET_LOCATIONS', locationsWithLabels)
      },
      (error) => {
        commit('SET_ERROR', error)
      }
    )
  },
  fetchProductions({ commit }) {
    // prettier-ignore
    const query = `*[_type == "production"] {
      _id,
      _type,
      title,
      subtitle,
      artists,
      "slug": coalesce(slug.current, _id),
      dateStart,
      dateEnd,
      "seasonId": season->_id,
      "seasonTitle": season->title,
      "locationId": location->_id,
      "district": location->district,
      "productionType": productionType->title,
      "genres": genres[]->title,
      information,
      url,
      images
    } | order(dateStart desc, dateEnd desc)`

    return sanity.fetch(query).then(
      (items) => {
        commit('SET_PRODUCTIONS', items)
      },
      (error) => {
        commit('SET_ERROR', error)
      }
    )
  },
  highlightLocation({ commit }, location = null) {
    let locationId = location || null
    if (typeof location === 'object') {
      locationId = location._id
    }
    commit('SET_HIGHLIGHTED_LOCATION', locationId)
  }
}
